import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";

import { homeTexts } from "../../assets/texts";
import { QuickLinkCard } from "../../Components/Dashboard/QuickLinks/QuickLinkCard";
import { useCustomerContext } from "../../Context/CustomerContext";
import { useIsNavigatorStandard } from "../../hooks";
import AnotherZigzagIcon from "./icons/AnotherZigzag";
import MagnifyingGlassIcon from "./icons/MagnifyGlassIcon";
import ZigzagIcon from "./icons/Zigzag";
import SectionHeader from "./SectionHeader";

export default function QuickLinks() {
  const isStandard = useIsNavigatorStandard();
  const {
    customer: { id: customerId },
  } = useCustomerContext();

  const makeLink = (path: string) => `/customers/${customerId}/${path}`;

  return (
    <Box sx={{ width: "100%" }}>
      <SectionHeader text={homeTexts.QUICK_LINKS_TITLE} />

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <QuickLinkCard
            icon={<AnotherZigzagIcon />}
            iconText={"Analyze cloud infrastructure"}
            title={"Cloud Diagrams"}
            description={
              "Gain a clear, visual overview of your entire cloud architecture. Accelerate incident resolution and enable context-rich architecture discussions."
            }
            link={makeLink("analyze/cloud-diagrams")}
            linkText={isStandard ? "Learn more about Cloud Diagrams" : "Build diagrams on your AWS accounts"}
            feature="Cloud Diagrams"
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <QuickLinkCard
            icon={<ZigzagIcon />}
            iconText={"Automate FinOps workflows"}
            title={"CloudFlow"}
            description={
              "Put your FinOps processes on autopilot with our no code automation builder. Schedule resources, automate tagging and much more. "
            }
            link={makeLink("operate/cloudflow")}
            linkText={isStandard ? "Learn more about CloudFlow" : "Get started with pre-built blueprints"}
            feature="CloudFlow"
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <QuickLinkCard
            icon={<MagnifyingGlassIcon />}
            iconText={"Uncover optimization opportunities"}
            title={"Insights"}
            description={
              "Our recommendation service that helps you optimize cloud costs, enhance cloud infrastructure's security, and adopt best practices."
            }
            link={makeLink("optimize/insights")}
            linkText={isStandard ? "Learn more about Insights" : "View cloud optimization opportunities"}
            feature="Insights"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
